module.exports = __webpack_public_path__ + "img/lang.c21c5cf4.svg";